<template>
  <div class="page">
    <div class="page-content">
      <page-nav-bar currentServiceName="MoneyRoad" popoverName=".popoverDashboard" :subNavTitle="'Statistics'" :menuAccess="true"></page-nav-bar>
      <div class="layoutTop"/>
      <div class="container-fluid">

        <b-card>
          <b-tabs content-class="mt-3" fill align="center" active-nav-item-class="font-weight-bold">

            <!-- GRAPH BY STATUS -->
            <b-tab title="Statistics by status" active>
              <b-card-text class="borderRounded">
                <graph-panel
                  graphTitle="Amount of the transactions"
                  :periodes="['day','week','month','year']"
                  @fetch-periode="fetchGraphStatus($event)"
                  @filter-graph="filterStatus($event)"
                  @clear-filter="clearFilterStatus()"
                  :ibans="ibans"
                  :contacts="contacts"
                  trueValueLabel="Show Amount"
                  falseValueLabel="Show Number"
                  v-model="showingStatus"
                >
                  <graph-by-status :showAmountNotNumber="showingStatus"></graph-by-status>
                </graph-panel>
              </b-card-text>
            </b-tab>

            <!-- GRAPH BY BALANCE -->
            <b-tab title="Statistics by balance">
              <b-card-text class="borderRounded">
                <graph-panel
                  graphTitle="Sent and Received Transactions"
                  :periodes="['day','week','month','year']"
                  @fetch-periode="fetchGraphBalance($event)"
                  @filter-graph="filterBalance($event)"
                  @clear-filter="clearFilterBalance()"
                  :ibans="ibans"
                  :contacts="contacts"
                  trueValueLabel="Show Transactions"
                  falseValueLabel="Show Treasury"
                  v-model="showingBalance"
                >
                  <graph-by-balance :showTransactionsNotTreasury="showingBalance"></graph-by-balance>
                </graph-panel>
              </b-card-text>
            </b-tab>

            <!-- GRAPH BY CONTACT CREDITOR -->
            <b-tab title="Statistics by creditors">
              <b-card-text class="borderRounded">
                <graph-panel
                  graphTitle="Creditors (sent transactions)"
                  :periodes="['day','week','month','year']"
                  @fetch-periode="fetchGraphContact($event)"
                  @filter-graph="filterContact($event)"
                  @clear-filter="clearFilterContact()"
                  :ibans="ibans"
                  :contacts="contacts"
                  trueValueLabel="Show Amount"
                  falseValueLabel="Show Number"
                  v-model="showingContact"
                >
                  <graph-by-contact :showSentNotReceived="true" :showAmountNotNumber="showingContact"></graph-by-contact>
                </graph-panel>
              </b-card-text>
            </b-tab>

            <!-- GRAPH BY CONTACT DEBTOR -->
            <b-tab title="Statistics by debtors">
              <b-card-text class="borderRounded">
                <graph-panel
                  graphTitle="Debtors (received transactions)"
                  :periodes="['day','week','month','year']"
                  @fetch-periode="fetchGraphContact($event)"
                  @filter-graph="filterContact($event)"
                  @clear-filter="clearFilterContact()"
                  :ibans="ibans"
                  :contacts="contacts"
                  trueValueLabel="Show Amount"
                  falseValueLabel="Show Number"
                  v-model="showingContact"
                >
                  <graph-by-contact :showSentNotReceived="false" :showAmountNotNumber="showingContact"></graph-by-contact>
                </graph-panel>
              </b-card-text>
            </b-tab>

          </b-tabs>
        </b-card>

      </div>
    </div>
  </div>
</template>

<script>
import pageNavBar from '@/components/common/pageNavBar.vue'
import graphByStatus from '@/pages/statistics/components/GraphByStatus.vue'
import graphByBalance from '@/pages/statistics/components/GraphByBalance.vue'
import graphByContact from '@/pages/statistics/components/GraphByContact.vue'
import graphPanel from '@/pages/statistics/components/GraphPanel.vue'

export default {
  components: {
    'page-nav-bar': pageNavBar,
    'graph-by-status': graphByStatus,
    'graph-by-balance': graphByBalance,
    'graph-by-contact': graphByContact,
    'graph-panel': graphPanel
  },
  data () {
    return {
      amount: true,
      pStatus: 'month',
      ibanStatus: [],
      contactStatus: [],
      ibans: [],
      contacts: [],
      showingStatus: true,
      showingBalance: true,
      showingContact: true
    }
  },
  created () {
    this.$engine.monitoring.initAllGraphs('month')
    this.ibans = this.$engine.bankAccounts.get().map(entry => ({name: entry.name, iban: entry.iban}))
    this.contacts = this.$engine.contacts.get().map(entry => ({id: entry.identifier, alias: entry.label}))
  },
  mounted () {
    this.$root.$on('bv::dropdown::hide', bvEvent => {
      if (!this.ibanOpenStatus) {
        bvEvent.preventDefault()
      }
    })
  },
  methods: {
    // Fetch Methods
    fetchGraphStatus (periode) {
      this.$engine.monitoring.fetchGraphByStatus(periode)
    },
    fetchGraphBalance (periode) {
      this.$engine.monitoring.fetchGraphByBalance(periode)
    },
    fetchGraphContact (periode) {
      this.$engine.monitoring.fetchGraphByContact(periode)
    },

    // Filter Methods
    filterStatus ({ibans, contacts}) {
      this.$engine.monitoring.filterForGraphStatus(ibans, contacts)
    },
    filterBalance ({ibans, contacts}) {
      this.$engine.monitoring.filterForGraphBalance(ibans, contacts)
    },
    filterContact ({ibans, contacts}) {
      this.$engine.monitoring.filterForGraphContact(ibans, contacts)
    },

    // Clear Methods
    clearFilterStatus () {
      this.ibanStatus = []
      this.contactStatus = []
      this.$engine.monitoring.clearFilterForGraphStatus()
    },
    clearFilterBalance () {
      this.$engine.monitoring.clearFilterForGraphBalance()
    },
    clearFilterContact () {
      this.$engine.monitoring.clearFilterForGraphContact()
    }
  }
}
</script>

<style lang="css" scoped>
.borderRounded {
  border-radius:10px;
}
.separator {
  border-bottom: 1px solid silver;
  margin-top: 40px;
  margin-bottom: 40px;
}

.spacer {
  margin-top: 40px;
  margin-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// StatisticsPage.vue?7a108bda